import { FC } from 'react';

import Table from 'modules/_shared/Table';

import ObservationsSectionTableHeader from './ObservationsSectionTableHeader';
import ObservationsSectionTableBody from './ObservationsSectionTableBody';

const ObservationsSectionTable: FC = () => {
  const tableContent = (
    <>
      <ObservationsSectionTableHeader />
      <ObservationsSectionTableBody />
    </>
  );

  return <Table content={tableContent} />;
};

export default ObservationsSectionTable;
